// extracted by mini-css-extract-plugin
export var badge = "_t2-4";
export var selected = "_t2-1";
export var selectedOverlay = "_t2-5";
export var thumbnailButton = "_t2-0";
export var thumbnailFallback = "_t2-3";
export var thumbnailImage = "_t2-2";